import React, { useRef } from 'react';
import Cards from '../components/Cards';
import Footer from '../components/Footer';
import OurStory from '../components/OurStory';
import Navbar from '../components/navbar/Navbar';
import { useState } from 'react';
import Subscription from '../components/Subscription';
import Banner from '../components/Banner';
import WhyUsPage from '../components/WhyUsPage';
// import Deliverables from '../components/Deliverables';
import ProfesionalValue from '../components/ProfesionalValue';
// import Whyusd from '../components/Whyusd';

const Hompage = () => {
  

  const [clicked, isClicked] = useState(false);
  const modalRef = useRef();
  const handleModal = () => {
    modalRef.current.openModal();
  };

  return (
    <div className='overflow-hidden'>
      <Navbar
        clicked={clicked}
        isClicked={isClicked}
        handleModal={handleModal}
        modalRef={modalRef}
      />

      <Banner />
      {/* <WhyUs /> */}
      <WhyUsPage />
      <Cards />
      <ProfesionalValue />
      {/* <Deliverables /> */}
      <OurStory />
      <Subscription />
      <Footer />
    </div>
  );
};

export default Hompage;
